<template>
  <div class="lxm-contact-contact-info">
    <transition name="lxm-content-transition" mode="out-in">
      <lxm-panel v-if="!loading" :rows="baseRows"></lxm-panel>
    </transition>
    <transition name="lxm-content-transition" mode="out-in">
      <lxm-panel v-if="!loading" :rows="attachRows"></lxm-panel>
    </transition>
    <!--<h2 class="subtitle">志愿者 — 角色信息</h2>
    <lxm-panel :rows="roleRows"></lxm-panel>-->

    <transition name="lxm-content-transition" mode="out-in">
        <!--<h2 class="subtitle">统计信息</h2>-->
        <lxm-panel v-if="!loading && statisticsRows.length > 0" :rows="statisticsRows" :valueStyle="vStyle"></lxm-panel>
    </transition>

    <transition name="lxm-content-transition" mode="out-in">
      <div v-if="!loading && otherRows.length > 0">
        <!--<h2 class="subtitle">其他信息</h2>-->
        <lxm-panel v-if="!loading && otherRows.length > 0" :rows="otherRows" :valueStyle="vStyle" :newLineStyle="newLineStyle"></lxm-panel>
      </div>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/variables.styl'
</style>

<script>
  import LxmPanel from '../../common/LxmPanel.vue'
  import * as aTypes from '../../../../store/action-types'
  import * as mTypes from '../../../../store/mutation-types'
  export default {
    components: {
      LxmPanel
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CONTACT_GET_CONTACT]
      },
      state () {
        return this.$store.state.contact.contact.info
      },
      baseRows () {
        return [
          {
            key: {
              iconClass: 'lxm-panel__icon--org',
              text: '机构'
            },
            value: {
              type: 'text',
              data: this.state.org.name || '',
              arrow: this.state.org.name || ''
            },
            clicked: () => {
              if (this.state.org && this.state.org.id) {
                this.$store.commit(mTypes.TRANSITION_SET_BACK)
                this.$router.push({
                  path: '/main/contact/org',
                  query: { orgId: this.state.org.id }
                })
              }
            }
          },
          {
            key: {
              iconClass: 'lxm-panel__icon--category',
              text: '分类'
            },
            value: {
              type: 'tags',
              data: this.state.categories
            }
          },
          {
            key: {
              iconClass: 'lxm-panel__icon--tag',
              text: '标签'
            },
            value: {
              type: 'tags',
              data: this.state.tags
            }
          }
        ]
      },
      attachRows () {
        const state = this.$store.state.contact.contact
        return [
          {
            key: {
              iconClass: 'lxm-panel__icon--remark',
              text: '备注'
            },
            value: {
              type: 'text',
              data: `${state.numRemarks}条`,
              arrow: true
            },
            clicked: () => {
              this.$store.commit(mTypes.TRANSITION_SET_BACK)
              this.$router.push({
                path: '/main/contact/remark',
                query: this.$route.query
              })
            }
          },
          {
            key: {
              iconClass: 'lxm-panel__icon--attachment',
              text: '附件'
            },
            value: {
              type: 'text',
              data: `${state.numAttachments}个`,
              arrow: true
            },
            clicked: () => {
              this.$store.commit(mTypes.TRANSITION_SET_BACK)
              this.$router.push({
                path: '/main/contact/attachment',
                query: this.$route.query
              })
            }
          }
        ]
      },
      roleRows () {
        return [
          {
            key: {
              iconClass: 'lxm-panel__icon--size',
              text: '衣服尺码'
            },
            value: this.state.size
          }
        ]
      },
      statisticsRows () {
        return this.state.statistics
      },
      otherRows () {
        return this.state.others
      },
      vStyle () {
        return 'width: auto;\n' +
                'text-align: -webkit-auto;\n' +
                'white-space:normal;\n' +
                'word-break:break-all;\n' +
                'word-wrap:break-word;\n'
      },
      newLineStyle () {
        return 'margin-top: 5px;line-height:20px;float: left;'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Info.vue?d90482f8